import { React, useState } from "react";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import { InputTextarea } from 'primereact/inputtextarea';
import { InputText } from 'primereact/inputtext';
import { format } from 'date-fns';
import axios from "axios";

export const PregledPoruke = ( props ) => {
  let navigate = useNavigate();
  const loc = useLocation();
  const data = loc.state;
  const [valueTextField, setValueTextField] = useState(data.naslov !== null ? '[Re] ' + data.naslov : '');
  const [valueTextArea, setValueTextArea] = useState('');


  const handlePosaljiPoruku  = async () => {
    //console.log("Rest target: " + props.rest);
    const porukaData = { 
                          idPrimljenePoruke: data.id,
                          premaObliku: sessionStorage.getItem("premaObliku"),
                          godinaUpisa: sessionStorage.getItem("godinaUpisa"),
                          redniBroj: sessionStorage.getItem("redniBroj"),
                          predavac: data.id_predavaca,
                          vrijemeSlanja: format(new Date(), 'dd.MM.yyyy. HH:mm:ss.SSSX'),
                          polaznikPosiljatelj: 'true',
                          naslovPoruke: valueTextField,
                          tekstPoruke: valueTextArea
                        };
        
    const headers = { 
                    'Authorization': sessionStorage.getItem("token"),
                    'Content-Type': 'application/json'
    };

    const response = await axios.post( props.rest + sessionStorage.getItem("ustanova"), JSON.stringify(porukaData), { headers });

    if (response.status === 200) {
      console.log("Status: " + response.status);
      navigate('/poruke');
    } else {
      console.log("[Greška]: " + response.status);
    }
  }

  return (
    <div>
      <p className="page-title">Pregled poruke</p>
      <div>
      <p className="page-paragraph">Od: {data.posiljatelj}</p>
      <p className="page-paragraph">Naslov: {data.naslov}</p>
      <p className="page-paragraph">Primljeno: { format(new Date(data.vrijeme_slanja), 'dd.MM.yyyy. HH:mm') }</p>
      <p className="page-paragraph"> {data.tekst_poruke}</p>
      <br /><br />
      </div>
      {data.vrijeme_odgovora === null ? <div className="page-paragraph">
                                          <div><InputText className="input-text" value={valueTextField} onChange={(e) => setValueTextField(e.target.value)} /></div><p></p>
                                          <div><InputTextarea className="input-text" rows={5} value={valueTextArea} onChange={ (e) => setValueTextArea(e.target.value)} /></div>
                                          <br />
                                          <Button className={"pi"} disabled={!valueTextArea} label="Pošalji" onClick={ () => { handlePosaljiPoruku()} } />
                                        </div> 
                                      : ""}
      <br /><br /><br /><br />
        <Button className={"pi "} disabled={false} label="Natrag" onClick={ () => { navigate('/poruke')} }/>
    </div>
  );
};

export default PregledPoruke;
